const navbarInit = () => {
  const langMenu: Element = document.querySelector('.language-menu');
  const navTop: HTMLElement = document.querySelector('.navigation-top');
  const open = document.querySelectorAll('.language-switch__toggle');
  const close: Element = document.querySelector('.language-menu__toggle');
  const togglerActive: string = 'active';

  open.forEach((el: HTMLElement) => {
    el.addEventListener('click', (e: Event) => {
      e.stopPropagation();
      navTop.classList.add(togglerActive);
      langMenu.classList.add(togglerActive);
    });
  });

  close.addEventListener('click', (e: Event) => {
    e.stopPropagation();
    navTop.classList.remove(togglerActive);
    langMenu.classList.remove(togglerActive);
  });
};

export default navbarInit;
